import { addActionBarItem } from '@vendure/admin-ui/core';
import gql from 'graphql-tag';
import { firstValueFrom } from 'rxjs';

const mutation = gql`
    mutation MyMutation($customerId: String!) {
        createSellerToken(input: { customer_id: $customerId }) {
            ... on CreateTokenResult {
                url
                token
            }
            ... on NoSellerAssignedError {
                errorCode
                message
            }
        }
    }
`;

export default [
    addActionBarItem({
        id: 'sellers-ui',
        locationId: 'customer-detail',
        icon: 'assign-user',
        label: 'Acessar loja como cliente',
        onClick: async (event, context) => {
            try {
                const customerId = context.route.snapshot.params.id;

                const response: any = await firstValueFrom(
                    context.dataService.mutate(mutation, {
                        customerId,
                    })
                );

                if ('errorCode' in response.createSellerToken) {
                    const { errorCode, message } = response.createSellerToken;
                    context.notificationService.error(
                        'Error: ' + errorCode + ': ' + message
                    );
                }

                if ('token' in response.createSellerToken) {
                    const { url, token } = response.createSellerToken;
                    window.open(url + token);
                }
            } catch (error: any) {
                context.notificationService.error(
                    'Error executing mutation: ' + error.message
                );
            }
        },
        requiresPermission: 'ReadSellers',
    }),
];
